"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCurrentUserPostHogPropertiesDocument = exports.UpdateMessagePairThumbsDocument = void 0;
exports.useUpdateMessagePairThumbsMutation = useUpdateMessagePairThumbsMutation;
exports.useGetCurrentUserPostHogPropertiesQuery = useGetCurrentUserPostHogPropertiesQuery;
exports.useGetCurrentUserPostHogPropertiesLazyQuery = useGetCurrentUserPostHogPropertiesLazyQuery;
exports.useGetCurrentUserPostHogPropertiesSuspenseQuery = useGetCurrentUserPostHogPropertiesSuspenseQuery;
var client_1 = require("@apollo/client");
var Apollo = __importStar(require("@apollo/client"));
var defaultOptions = {};
exports.UpdateMessagePairThumbsDocument = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation UpdateMessagePairThumbs($id: ID!, $input: OracleMessagePairUpdateInput!) {\n  oracleMessagePairUpdate(id: $id, input: $input) {\n    success\n    errors\n    oracleMessagePair {\n      id\n      thumbsValue\n    }\n  }\n}\n    "], ["\n    mutation UpdateMessagePairThumbs($id: ID!, $input: OracleMessagePairUpdateInput!) {\n  oracleMessagePairUpdate(id: $id, input: $input) {\n    success\n    errors\n    oracleMessagePair {\n      id\n      thumbsValue\n    }\n  }\n}\n    "])));
/**
 * __useUpdateMessagePairThumbsMutation__
 *
 * To run a mutation, you first call `useUpdateMessagePairThumbsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessagePairThumbsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessagePairThumbsMutation, { data, loading, error }] = useUpdateMessagePairThumbsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
function useUpdateMessagePairThumbsMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.UpdateMessagePairThumbsDocument, options);
}
exports.GetCurrentUserPostHogPropertiesDocument = (0, client_1.gql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    query GetCurrentUserPostHogProperties {\n  userInfoCurrent {\n    userInfo {\n      userTenureDays\n    }\n  }\n}\n    "], ["\n    query GetCurrentUserPostHogProperties {\n  userInfoCurrent {\n    userInfo {\n      userTenureDays\n    }\n  }\n}\n    "
    /**
     * __useGetCurrentUserPostHogPropertiesQuery__
     *
     * To run a query within a React component, call `useGetCurrentUserPostHogPropertiesQuery` and pass it any options that fit your needs.
     * When your component renders, `useGetCurrentUserPostHogPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useGetCurrentUserPostHogPropertiesQuery({
     *   variables: {
     *   },
     * });
     */
])));
/**
 * __useGetCurrentUserPostHogPropertiesQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserPostHogPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserPostHogPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserPostHogPropertiesQuery({
 *   variables: {
 *   },
 * });
 */
function useGetCurrentUserPostHogPropertiesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetCurrentUserPostHogPropertiesDocument, options);
}
function useGetCurrentUserPostHogPropertiesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetCurrentUserPostHogPropertiesDocument, options);
}
function useGetCurrentUserPostHogPropertiesSuspenseQuery(baseOptions) {
    var options = baseOptions === Apollo.skipToken ? baseOptions : __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(exports.GetCurrentUserPostHogPropertiesDocument, options);
}
var templateObject_1, templateObject_2;
